import { Component } from '@angular/core';
import { FBAbstractControl } from '../abstract.control';

@Component({
  selector: 'fb-controls-lookup',
  templateUrl: './lookup.component.html',
  styleUrls: [],
})
export class FBLookupComponent extends FBAbstractControl {
  constructor() {
    super();
  }

  static PROPERTIES() {
    return Object.freeze({
      common: {
        ...FBAbstractControl.DefaultProperties(),
      },
      booleans: {
        ...FBAbstractControl.BooleansProperties(),
      },
    });
  }
}
